import { appId, getAppIdEnum, isFromPcHome, isTeamSubscription } from '@/constants';
import { getAbInfo } from '@/utils/abtest';
import request from '@/utils/request';
import { getUrlParam } from '@/utils';
import { getClientId, getIncomeSource, isAppStorePay } from '@/utils/vip';
import {
  // CreateContinuousOrderParams,
  CreateContinuousOrderResponse,
  CreateOrderParams,
  CreateOrderResponse,
  FetchAccountLoginUrlParams,
  FetchAccountLoginUrlResponse,
  FetchContinuousOrderStatus,
  FetchContinuousOrderStatusResponse,
  FetchOrderStatusParams,
  FetchOrderStatusResponse,
  FetchProductListParams,
  FetchProductListResponse,
  FetchSubStatusResponse,
  FetchUserBatchSizeResponse,
  // PayParams,
  PayParamsResponse,
  CreateRransferIdResponse,
  FetchProductMacParmas,
  FetchProductMacResponse,
  ExchangeResponse,
  AvailableThirdPartyResponse,
  AvailableThirdPartyParams,
  EntranceAbParams,
  EntranceAbResponse,
  AuditVersionStatusResponse,
  CoinDetailResponse,
  PayContentResponse,
  BindRedemptionResponse,
  FetchSubscriptionEntranceEntriesData,
} from './index.d';

const getGidFromLocalStorage = () => {
  return window.localStorage.getItem('GID') || '123';
};

/** 订阅入口接口 sub_func：按业务 module_id 透传场景标识 */
const getSubFunc = () => {
  const moduleId = getUrlParam('module_id') || '';
  switch (moduleId) {
    case 'product_kit_web':
      // 商品套图、A+详情、服饰穿戴、爆款图复刻
      return 'gemini_ai_product';
    case 'viral_video_web':
      // 爆款视频
      return 'viral_video_generate_hosted';
    case 'story_book_web':
      // AI 绘本
      return 'picture_book';
    case 'ailogo':
      // AI LOGO
      return 'ai_logo';
    case 'znxc':
      // AI 消除
      return 'znxc';
    case 'roboneo_web':
      // agent编辑器
      return 'ai agent';
    default:
      return '';
  }
};

export const fetchProductList = async (params: FetchProductListParams) => {
  return await request<FetchProductListResponse>(`${process.env.REACT_APP_API_VIP_HOST}/product`, {
    method: 'GET',
    params: Object.assign({}, params, {
      app_id: appId,
      gid: getGidFromLocalStorage(),
    }),
  });
};

export const fetchSubStatus = async () => {
  return await request<FetchSubStatusResponse>(
    `${process.env.REACT_APP_API_VIP_HOST}/subs/offer_elg`,
    {
      method: 'GET',
      params: {
        app_id: appId,
        gid: getGidFromLocalStorage(),
      },
    }
  );
};

export const fetchAccountLoginUrl = async (params: FetchAccountLoginUrlParams) => {
  return await request<FetchAccountLoginUrlResponse>(
    `${process.env.REACT_APP_API_VIP_HOST}/user/redirect_url`,
    {
      method: 'GET',
      params: Object.assign({}, params, {
        app_id: appId,
        gid: getGidFromLocalStorage(),
        client_id: getClientId(),
      }),
    }
  );
};

export const createOrder = async (params: CreateOrderParams) => {
  return await request<CreateOrderResponse>(
    `${process.env.REACT_APP_API_VIP_HOST}/subs/trade_order`,
    {
      method: 'POST',
      data: Object.assign({}, params, {
        app_id: appId,
        gid: getGidFromLocalStorage(),
      }),
    }
  );
};

export const createContinuousOrder = async (params: any) => {
  const bodyFormData = new FormData();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    bodyFormData.append(key, value);
  });
  return await request<CreateContinuousOrderResponse>(
    `${process.env.REACT_APP_API_SUB_HOST}/h5/transaction/create.json`,
    {
      method: 'POST',
      data: bodyFormData,
      headers: {
        'access-token': window.localStorage.getItem('access_token') as string,
        'content-type': 'multipart/form-data',
      },
    }
  );
};

export const fetchPayParams = async (params: any) => {
  const bodyFormData = new FormData();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    bodyFormData.append(key, value);
  });
  return await request<PayParamsResponse>(
    `${process.env.REACT_APP_API_PAY_HOST}/payment/cashier/agreement.json`,
    {
      method: 'POST',
      data: bodyFormData,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }
  );
};

/**
 * 获取用户批处理次数
 * @param params
 * @returns
 */
export const fetchUserBatchSize = () => {
  return request<FetchUserBatchSizeResponse>(
    `${process.env.REACT_APP_API_VIP_HOST}/user/batch_size`,
    {
      method: 'GET',
      params: {
        app_id: appId,
        gid: getGidFromLocalStorage(),
      },
    }
  );
};

export const fetchOrderStatus = (params: FetchOrderStatusParams) => {
  return request<FetchOrderStatusResponse>(
    `${process.env.REACT_APP_API_VIP_HOST}/subs/order_status`,
    {
      method: 'GET',
      params: Object.assign({}, params, {
        app_id: appId,
        gid: getGidFromLocalStorage(),
      }),
    }
  );
};

export const fetchContinuousOrderStatus = (params: FetchContinuousOrderStatus) => {
  return request<FetchContinuousOrderStatusResponse>(
    `${process.env.REACT_APP_API_SUB_HOST}/h5/transaction/progress_check.json`,
    {
      method: 'GET',
      params: Object.assign({}, params, {
        app_id: appId,
        gid: getGidFromLocalStorage(),
      }),
    }
  );
};

export const createRransferId = (params: any) => {
  const bodyFormData = new FormData();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    bodyFormData.append(key, value);
  });

  return request<CreateRransferIdResponse>(
    `${process.env.REACT_APP_API_SUB_HOST}/h5/transaction/transfer_data.json`,
    {
      method: 'POST',
      data: bodyFormData,
      headers: {
        'access-token': window.localStorage.getItem('access_token') as string,
        'content-type': 'multipart/form-data',
      },
    }
  );
};

export const fetchProductListOfMac = (params: FetchProductMacParmas) => {
  return request<FetchProductMacResponse>(`${process.env.REACT_APP_API_VIP_HOST}/subs/product`, {
    method: 'GET',
    params: Object.assign({}, params, {
      gid: getGidFromLocalStorage(),
    }),
  });
};

/**
 *
 * 接口 [兑换码-兑换权益↗](/v2/h5/promote/use_redeem_code.json)，直接调用订阅中台接口
 * @docs: https://api-mock.meitu-int.com/project/1698/interface/api/135011
 */
export const exchange = async (code: string) => {
  return await request<ExchangeResponse>(
    `${process.env.REACT_APP_API_SUB_HOST}/v2/h5/promote/use_redeem_code.json`,
    {
      method: 'POST',
      data: {
        app_id: getAppIdEnum().MEITUSHEJISHI,
        redeem_code: code, // 兑换码，多个用逗号隔开
        device: 3, // 兑换设备：1-IOS 2-Android 3-PC/WEB 4-MAC
      },
      headers: {
        'content-type': 'application/json',
        'access-token': window.localStorage.getItem('access_token') || '',
      },
    }
  );
};
/**
 *
 * 邀请码兑换
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/219457
 */
export const bindRedemption = async (code: string) => {
  const bodyFormData = new FormData();
  bodyFormData.append('code', code);
  return await request<BindRedemptionResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/redemption/bind`,
    {
      method: 'POST',
      data: bodyFormData,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

/**
 *
 * 接口 [兑换码-兑换业务侧的会员权益↗](/sub_promote/exchange)，调用业务侧接口
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/192773
 */
export const exchangeSubPromote = async (code: string) => {
  const bodyFormData = new FormData();
  bodyFormData.append('code', code);
  return await request<ExchangeResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/sub_promote/exchange`,
    {
      method: 'POST',
      data: bodyFormData,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

//大账号 第三方登陆
export const fetchAvailableThirdParty = async (params: AvailableThirdPartyParams) => {
  return await request<AvailableThirdPartyResponse>(
    `${process.env.REACT_APP_API_PRO_HOST}/api/v1/configure/available_third_party`,
    {
      method: 'GET',
      params,
    }
  );
};

/**
 * 接口 [订阅购买页AB实验控制接口↗](/subs/entrance_ab)
 * @docs: https://api-mock.meitu-int.com/project/1083/interface/api/106302
 */
export const entranceAb = async function (params: EntranceAbParams) {
  return await request<EntranceAbResponse>(
    `${process.env.REACT_APP_API_VIP_HOST}/subs/entrance_ab`,
    {
      method: 'GET',
      params,
    }
  );
};

/**
 * 订阅页各场景商品入口标识
 * @see docs/superpowers/specs/2026-03-31-subscription-entries-api-design.md
 */
export const fetchSubscriptionEntranceEntries = async () => {
  const abInfo = getAbInfo();
  const headers: Record<string, string> = {};

  // 团队版/PC内嵌/抠图项目/PC首页，不做实验，不需要透传abInfo
  if (abInfo && !isTeamSubscription && getIncomeSource() === 'MTXX-WEB' && !isFromPcHome) {
    headers['ab_info'] = JSON.stringify(abInfo);
  }

  return await request<FetchSubscriptionEntranceEntriesData>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/v1/purchase/subscribe_entries`,
    {
      method: 'GET',
      params: {
        source: getIncomeSource(),
        iap: isAppStorePay() ? 1 : 0,
        gid: getGidFromLocalStorage(),
        website: isFromPcHome ? 'pc' : '',
        sub_func: getSubFunc(),
      },
      headers,
    }
  );
};

/**
 * 检查是否华为审核版本
 * @param params
 * @returns
 */
export const fetchAuditVersionStatus = (params: { channel: string; version: string }) => {
  return request<AuditVersionStatusResponse>(
    `${process.env.REACT_APP_API_PRO_HOST}/api/v1/configure/audit_version`,
    {
      method: 'GET',
      params,
    }
  );
};
/**
 * 接口 [查询用户美豆明细↗](/v1/coin/coin_detail)
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/136229
 */
export const coinDetail = async function () {
  return await request<CoinDetailResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/v1/coin/coin_detail`,
    {
      method: 'GET',
    }
  );
};

export const fetchPayContentInfo = async (params: any) => {
  const bodyFormData = new FormData();
  Object.keys(params).forEach((key: string) => {
    const value = params[key];
    bodyFormData.append(key, value);
  });
  return await request<PayContentResponse>(
    `${process.env.REACT_APP_API_PAY_HOST}/payment/cashier/pay.json `,
    {
      method: 'POST',
      data: bodyFormData,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  );
};
